import {
    AutomationsTemplateId,
    templates,
    type AutomationsTemplate,
} from "@/components/environments/onboarding/automations-template";
import { Button } from "@/components/flexkit/Button";
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/podkit/dialog/Dialog";
import { CopyableInput } from "@/components/podkit/forms/CopyableInput";
import { CopyableTextArea } from "@/components/podkit/forms/CopyableTextArea";
import { Text } from "@/components/podkit/typography/Text";
import { TrackLocations } from "@/hooks/use-segment";
import { useCallback, type FC } from "react";

export const AutomationsTemplateModal: FC<{
    onClose: () => void;
}> = ({ onClose }) => {
    const handleOpenChange = useCallback(
        (nextOpen: boolean) => {
            if (!nextOpen) {
                onClose();
            }
        },
        [onClose],
    );

    return (
        <Dialog open onOpenChange={handleOpenChange}>
            <DialogContent
                className="max-w-[600px]"
                data-track-location={TrackLocations.EnvironmentOnboardingAutomationsTemplateModal}
            >
                <DialogHeader>
                    <DialogTitle>Add automations</DialogTitle>
                    <DialogDescription>Create an automations.yaml to run tasks and services</DialogDescription>
                </DialogHeader>

                <DialogBody className="overflow-x max-w-full">
                    <TemplateContent template={templates[AutomationsTemplateId.Example]} />
                </DialogBody>

                <DialogFooter>
                    <DialogClose asChild>
                        <Button type="button" variant="outline">
                            Close
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

const TemplateContent: FC<{ template: AutomationsTemplate }> = ({ template }) => {
    return (
        <div className="flex flex-col gap-2">
            <Text>
                Add the following contents to <span className="font-mono">.ona/automations.yaml</span>
            </Text>
            <CopyableTextArea
                value={template.automationsFileContents}
                className="min-h-[140px]"
                copyable
                data-tracking-id="copy-automations-template"
            />
            <Text>And configure the environment to use the Automations using</Text>
            <CopyableInput
                value="gitpod automations update -s .ona/automations.yaml"
                copyable
                data-tracking-id="copy-automations-update-command"
            />
        </div>
    );
};
